import {
    getManagerBlocks,
    forgetManagerBlock
} from '@/services/shift-report/service'


const state = () => ({
    blocks: {
        current_page: 0,
        data: [],
        first_page_url: '',
        from: 0,
        last_page: 1,
        last_page_url: '',
        next_page_url: null,
        path: '',
        per_page: 0,
        prev_page_url: null,
        to: 0,
        total: 0
    },
    processing: true,
    forgetProcessing: false
})

const mutations = {
    SET_BLOCKS(state, blocks = {
        current_page: 0,
        data: [],
        first_page_url: '',
        from: 0,
        last_page: 1,
        last_page_url: '',
        next_page_url: null,
        path: '',
        per_page: 0,
        prev_page_url: null,
        to: 0,
        total: 0
    } ) {
        state.blocks = blocks
    },
    SET_PROCESSING(state, value = true) {
        state.processing = value
    },
    SET_FORGET_PROCESSING(state, value = false) {
        state.forgetProcessing = value
    },
    EDIT_BLOCK(state, id = 0) {
        state.blocks.data[id].is_blocked = false
    },
}

const actions = {
     async getManagerBlock({ commit }, values = { page: 1 }) {
        commit('SET_PROCESSING')
       const { data, error } = await getManagerBlocks(values).finally(() => commit('SET_PROCESSING', false ))
        if (error) {
            return alert('Ocurrió un error intente mas tarde')
        } else {
            const {
                current_page,
                data: blocks,
                first_page_url,
                from,
                last_page,
                last_page_url,
                next_page_url,
                path,
                per_page,
                prev_page_url,
                to,
                total} = data
           commit('SET_BLOCKS', {
                current_page,
                data: blocks,
                first_page_url,
                from,
                last_page,
                last_page_url,
                next_page_url,
                path,
                per_page,
                prev_page_url,
                to,
                total
            })
        }
    },
    async forgetBlock({ commit }, { id, index }) {
        commit('SET_FORGET_PROCESSING', true)
        const { error } = await forgetManagerBlock(id).finally(() => commit('SET_FORGET_PROCESSING'))
        if (error) {
            return alert('Ocurrió un error intente mas tarde')
        } else {
            commit('EDIT_BLOCK', index)
        }

    }
}

const getters = {
    getProcessing: (state) => { return state.processing },
    getForgetProcessing: (state) => { return state.forgetProcessing },
    getBlocks: (state) => { return state.blocks },

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
